export default "__VITE_ASSET__45acc174__"